<div class="mt-40">
  <!-- <ecp-breadcrumb></ecp-breadcrumb> -->
  <div class="container mt-30">
    <div class="row is-flex">
      <div class="col s6 text-align-left">
        <a class="btn btn-outline" type="button" [routerLink]="url">
          Back to frame returns
        </a>
      </div>
      <ng-container *ngIf="(frameReturns$ | async).length === 0; else frameReturns">
        <div class="col s12 m8" *ngIf="user$ | async">
          <div class="container">
            No frames are selected to return. Please click the above button to select frames..
          </div>
        </div>
      </ng-container>
      <ng-template #frameReturns>
        <div class="col s12 m8 l10">
          <div class="container">
            <ecp-returns-cart-details></ecp-returns-cart-details>
          </div>
        </div>
        <div class="col s12 m4 l2">
          <div>
            <ecp-returns-cart></ecp-returns-cart>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
